import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, renderSlot as _renderSlot, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = {
  key: 1,
  class: "logo"
}
const _hoisted_3 = ["srcset"]
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "language-display" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "language-display__country" }
const _hoisted_8 = {
  key: 0,
  class: "language-selector__items"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "language-selector__language" }

import { useI18n } from "vue-i18n"
import config from "../../config"
import { ref, watch } from "vue"

interface PageHeaderProps {
  headerClass?: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'PageHeader',
  props: {
    headerClass: { default: "" }
  },
  setup(__props: any) {



const { availableLocales, locale } = useI18n()

const languages = ref(availableLocales)
const selected = ref(locale)
const isLanguageSelectorVisible = ref(false)

watch(locale, (newValue) => {
  selected.value = newValue
})

const changeLang = (lang: string) => {
  locale.value = lang
  selected.value = locale.value
  isLanguageSelectorVisible.value = false
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", {
    class: _normalizeClass(["header", __props.headerClass])
  }, [
    _createVNode(_component_router_link, {
      to: "/",
      class: "logo__link"
    }, {
      default: _withCtx(() => [
        (
          __props.headerClass === 'header--start-charging' ||
          __props.headerClass === 'header--charging'
        )
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              class: "logo header__logo",
              src: `${_unref(config).imagesPath}/logo-light.svg`,
              alt: ""
            }, null, 8, _hoisted_1))
          : (_openBlock(), _createElementBlock("picture", _hoisted_2, [
              _createElementVNode("source", {
                srcset: `${_unref(config).imagesPath}/logo-light.svg`,
                media: "(prefers-color-scheme: dark)"
              }, null, 8, _hoisted_3),
              _createElementVNode("img", {
                src: `${_unref(config).imagesPath}/logo.svg`,
                class: "header__logo",
                alt: ""
              }, null, 8, _hoisted_4)
            ]))
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", {
        class: "language-display__display",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (isLanguageSelectorVisible.value = !isLanguageSelectorVisible.value))
      }, [
        _createElementVNode("img", {
          class: "language-display__flag",
          src: `${_unref(config).imagesPath}/flag-${selected.value}.svg`,
          alt: ""
        }, null, 8, _hoisted_6),
        _createElementVNode("span", _hoisted_7, _toDisplayString(selected.value), 1)
      ]),
      (isLanguageSelectorVisible.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(languages.value, (lang, index) => {
              return (_openBlock(), _createElementBlock("a", {
                key: index,
                class: "language-selector__item",
                href: "#",
                onClick: _withModifiers(($event: any) => (changeLang(lang)), ["prevent"])
              }, [
                _createElementVNode("img", {
                  class: "language-selector__flag",
                  src: `${_unref(config).imagesPath}/flag-${lang}.svg`,
                  alt: ""
                }, null, 8, _hoisted_10),
                _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t("common.lang." + lang)), 1)
              ], 8, _hoisted_9))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ]),
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})